<template>
    <GeneralLedger
        :companyId="companyId"
        :accountingPeriodId="accountingPeriod.id"
        :accountingClosingId="accountingClosing ? accountingClosing.id : ''"
        :store="true"
        :enableAuditedAccountableAccounts="true"
        v-if="companyId && accountingPeriod"
    >
    </GeneralLedger>
</template>

<script lang="ts">
import { State2Way } from "@/decorators";
import { checkAccessRights } from "../services/accessRightServices";

import GeneralLedger from "./GeneralLedger2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
    },
})
export class GeneralLedgerPage extends Vue {
    get companyId() {
        return this.$store.state?.selected_company?.id;
    }

    get currentUser() {
        return this.$store.state?.user;
    }

    get isAuthorized() {
        const authorized = checkAccessRights(this.currentUser, "accounting", "generalLedger");
        return authorized;
    }

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod!: any;

    @State2Way("updateSelectedAccountingClosing", "accountingPeriod.selectedAccountingClosing")
    accountingClosing!: any;
}

export default toNative(GeneralLedgerPage);
</script>
